/**
 * Estado inicial del formulario F-22 - Régimen 14 D N°8 (Pro Pyme Transparente)
 *
 * Común a los años tributarios cuyos recuadros 22 y 23 tienen los mismos códigos
 * (AT 2025 y AT 2026, verificado contra los F22 oficiales del SII); cada año lo arma
 * con su número en <año>/14d8/persistence.js.
 *
 * La base imponible no se ingresa aquí: viene de la DJ 1947 del mismo año, que se
 * prepara antes (data.dj1947). Aquí van solo los antecedentes del recuadro 23 que no
 * están en la DJ. Los campos calculados se generan con formulas.js.
 */

const crearEstadoInicial = (anioTributario) => ({
  // Metadatos
  anioTributario,
  anioComercial: anioTributario - 1,
  regimen: '14d8',

  // DJ 1947 guardada del mismo año: { id_declaracion, base, propietarios, reparto }.
  // null si todavía no se prepara.
  dj1947: null,

  // ===== ANTECEDENTES (recuadro 23) =====
  antecedentes: {
    // Socios (desde Socios y dividendos), para el capital aportado al iniciar actividades
    socios: [],

    // CPT o CPTS del F22 anterior (códigos 1580 y 1582)
    cptInicialPositivo: 0,
    cptInicialNegativo: 0,

    // Aumentos y disminuciones efectivas de capital del ejercicio (1574 y 1575)
    aumentosCapital: 0,
    disminucionesCapital: 0,

    // Partidas de gastos no aceptados (1577)
    pagoInteresesMultas: 0,
    pagoIDPCAnterior: 0,

    // Otras partidas a agregar o deducir (1584 y 1585)
    otrasPartidasAgregar: 0,
    otrasPartidasDeducir: 0,
  },
});

module.exports = { crearEstadoInicial };
